import { setCheckButtons, setTableButtons } from '@/utils/getbuttons.js'
import {
  REALNAME_GROUPS,
  PRECLASS_GROUPS,
  ORG_TYPE_OPTIONS,
  isTemplateVisible
} from '@/utils/reportCategories'

function isOrgStep(step) {
  return String(step || '').indexOf('Org') >= 0
}

function isPreClassStep(step) {
  return String(step || '').indexOf('preClass') === 0
}

function groupOptions(category) {
  return category === 'preClass' ? PRECLASS_GROUPS : REALNAME_GROUPS
}

function templateDialog(mode) {
  return {
    width: '50%',
    title: (params) => {
      const org = isOrgStep(params.step)
      if (params.pageStatus === 'add') return org ? '新增机构模板' : '新增系统模板'
      if (params.pageStatus === 'edit') return org ? '编辑机构模板' : '编辑系统模板'
      return '报表模板'
    },
    addFun: mode === 'org' ? 'dataAnalysis/saveOrgTemplate' : 'dataAnalysis/saveSystemTemplate',
    editFun: mode === 'org' ? 'dataAnalysis/saveOrgTemplate' : 'dataAnalysis/saveSystemTemplate',
    getListFun: 'dataAnalysis/getReportTemplates',
    formParams: {
      uid: '',
      customUid: '',
      templateCode: '',
      templateName: '',
      templateGroupCode: (params) => {
        return groupOptions(isPreClassStep(params.step) ? 'preClass' : 'realname')[0].value
      },
      templateGroupName: (params) => {
        return groupOptions(isPreClassStep(params.step) ? 'preClass' : 'realname')[0].label
      },
      sort: '',
      isShow: mode === 'org' ? 'true' : 'false',
      userCustom: 'false',
      applicableOrgTypes: ['simPro', 'laborCom'],
      reportBaseUrl: '',
      reportTemplateName: '',
      mark: ''
    },
    formRules: {
      templateCode: [{ required: true, message: '请选择或输入模板编码', trigger: 'change' }],
      templateName: [{ required: true, message: '请输入报表名称', trigger: 'blur' }],
      templateGroupCode: [{ required: true, message: '请选择分组', trigger: 'change' }],
      applicableOrgTypes: [{ required: true, message: '请选择适用机构类型', trigger: 'change' }]
    },
    formData: (params) => {
      const org = isOrgStep(params.step)
      const adding = params.pageStatus === 'add'
      const category = isPreClassStep(params.step) ? 'preClass' : 'realname'
      const fields = []
      if (org && adding) {
        fields.push({
          key: 'templateCode',
          label: '选择模板',
          type: 'select',
          filterable: true,
          checkByValue: true,
          span: 24,
          placeholder: '请选择可添加的系统模板',
          options: (inner) => inner.state.dataAnalysis.availableTemplates || []
        })
        fields.push({
          key: 'previewTpl',
          label: '模板预览',
          type: 'button',
          buttons: [{ name: '预览模板', code: 'previewTpl', icon: 'el-icon-search' }]
        })
      }
      fields.push({
        key: 'templateName',
        label: '报表名称',
        type: 'input'
      })
      if (!org) {
        fields.push({
          key: 'templateCode',
          label: '模板编码',
          type: 'input',
          disabled: params.pageStatus === 'edit'
        })
      } else if (!adding) {
        fields.push({
          key: 'templateCode',
          label: '模板编码',
          type: 'input',
          disabled: true
        })
      }
      fields.push({
        key: 'templateGroupCode',
        label: '分组',
        type: 'select',
        checkByValue: true,
        options: groupOptions(category)
      })
      if (!org) {
        fields.push({
          key: 'isShow',
          label: '初始化显示',
          type: 'select',
          checkByValue: true,
          options: [
            { label: '是', value: 'true' },
            { label: '否', value: 'false' }
          ]
        })
        fields.push({
          key: 'userCustom',
          label: '用户定制',
          type: 'select',
          checkByValue: true,
          options: [
            { label: '是', value: 'true' },
            { label: '否', value: 'false' }
          ]
        })
        fields.push({
          key: 'applicableOrgTypes',
          label: '适用机构类型',
          type: 'select',
          multiple: true,
          checkByValue: true,
          span: 24,
          options: ORG_TYPE_OPTIONS
        })
        fields.push({
          key: 'reportBaseUrl',
          label: '报表地址',
          type: 'input',
          span: 24,
          placeholder: '外链报表地址，原生报表可空'
        })
        fields.push({
          key: 'reportTemplateName',
          label: '报表文件',
          type: 'input',
          span: 24,
          placeholder: '外链模板名，原生报表可空'
        })
        fields.push({
          key: 'mark',
          label: '备注',
          type: 'input',
          inputType: 'textarea',
          span: 24,
          placeholder: '选填，可填写模板说明'
        })
      }
      return fields
    }
  }
}

function templatePage(name, title, mode) {
  return {
    name: name,
    theme: title,
    componentTypes:
      mode === 'org'
        ? ['navigate', 'pageTabs', 'navBar', 'check', 'tables', 'dialogForm']
        : ['navigate', 'pageTabs', 'check', 'tables', 'dialogForm'],
    getListFun: 'dataAnalysis/getReportTemplates',
    deleteFun: mode === 'org' ? 'dataAnalysis/deleteOrgTemplate' : '',
    deleteConfirm: '删除后该报表不再机构中显示，也不在本列表中显示，需要时请重新新增。',
    headButtons: setCheckButtons(['新增']),
    tagInfo:
      mode === 'org'
        ? '左侧切换机构后，可新增、停用或删除该机构报表。停用后机构内不再显示，删除后需重新新增。分组名称对应机构报表页的 Tab。'
        : '系统模板是模板库。勾选初始化显示后，新机构会按适用机构类型自动同步；用户定制模板不会同步给新机构。分组名称对应机构报表页的 Tab。',
    expandAll: true,
    rowKey: 'uid',
    outListHeight: 240,
    rowData: (params) => params.state.dataAnalysis.templateTree || [],
    columns: () => {
      const cols = [
        { prop: 'templateName', label: '\xa0\xa0报表名称', align: 'left', minWidth: '200px' },
        { prop: 'templateCode', label: '模板编码', minWidth: '180px' }
      ]
      if (mode === 'org') {
        cols.push({
          prop: 'showLabel',
          label: '是否启用',
          width: '90px',
          tag: [
            { label: '启用', type: 'success' },
            { label: '停用', type: 'danger' }
          ]
        })
      } else {
        cols.push({ prop: 'showLabel', label: '初始化显示', width: '100px' })
        cols.push({ prop: 'orgTypesLabel', label: '适用机构类型', minWidth: '160px' })
        cols.push({ prop: 'userCustomLabel', label: '用户定制', width: '90px' })
      }
      cols.push({ prop: 'sort', label: '排序', width: '80px' })
      cols.push({
        label: '操作',
        width: '400px',
        buttons: () => {
          return (row) => {
            if (!row || row.isGroup) return []
            const names = ['编辑']
            if (mode === 'org') {
              names.push(isTemplateVisible(row.isShow) ? '停用' : '启用')
              names.push('删除')
            }
            names.push('上移', '下移')
            return setTableButtons(names)
          }
        }
      })
      return cols
    },
    detailPage: [
      { buttonName: '新增', type: 'dialogForm', name: name, pageStatus: 'add' },
      { buttonName: '编辑', type: 'dialogForm', name: name, pageStatus: 'edit', checkType: 'useRowData' }
    ],
    [name]: templateDialog(mode)
  }
}

const report = {
  pageTabs: (params) => {
    const step = params.step || ''
    if (step.indexOf('SystemList') >= 0 || step.indexOf('OrgList') >= 0) {
      const preClass = isPreClassStep(step)
      return [
        {
          label: '系统模板',
          theme: 'report',
          step: preClass ? 'preClassSystemList' : 'laborSystemList',
          stepLabel: preClass ? '班前教育系统模板' : '劳务用工系统模板',
          checkFun: 'dataAnalysis/getReportTemplates'
        },
        {
          label: '机构模板',
          theme: 'report',
          step: preClass ? 'preClassOrgList' : 'laborOrgList',
          stepLabel: preClass ? '班前教育机构模板' : '劳务用工机构模板',
          checkFun: 'dataAnalysis/getReportTemplates'
        }
      ]
    }
    if (step.slice(0, 8) === 'realname') {
      return [
        {
          label: '管理报表',
          theme: 'proRealnameReport',
          step: 'realnameManageRepo',
          stepLabel: '管理报表',
          checkFun: ''
        },
        {
          label: '查询报表',
          theme: 'proRealnameReport',
          step: 'realnameQueryRepo',
          stepLabel: '查询报表',
          checkFun: ''
        }
      ]
    }
  },
  navBar: {
    navTitle: '机构列表',
    queryFun: 'dataAnalysis/getReportTemplates'
  },
  laborSystem: templatePage('laborSystem', '劳务用工系统模板', 'system'),
  laborOrg: templatePage('laborOrg', '劳务用工机构模板', 'org'),
  preClassSystem: templatePage('preClassSystem', '班前教育系统模板', 'system'),
  preClassOrg: templatePage('preClassOrg', '班前教育机构模板', 'org'),
  realnameManage: {
    name: 'realnameManage',
    theme: '管理报表',
    componentTypes: ['navigate', 'pageTabs', 'navBar']
  },
  realnameQuery: {
    name: 'realnameQuery',
    theme: '查询报表',
    componentTypes: ['navigate', 'pageTabs', 'navBar']
  }
}

export default report
